var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.818 9.617c-2.195-1.102-1.463-3.556.915-3.556c2.637 0 4.39 1.653 4.755 2.204l.548-.55c-1.097-1.47-2.926-2.572-5.303-2.572c-.933 0-1.973.236-2.762.638c-1.67.85-3.546 3.909-1.08 5.855c1.047.826 2.331 1.41 3.474 1.928c1.603.728 2.928 1.33 2.928 2.296c0 1.653-4.042 3.288-7.133.184l-.731.367c1.153 1.158 2.643 1.948 3.601 2.238s2.541.266 3.6 0c2.114-.53 3.807-2.254 3.47-4.25c-.39-2.307-2.703-3.263-4.742-4.105c-.547-.226-1.075-.444-1.54-.678M8.806 6.862c-.894.62-1.829 3.021-.183 4.223c.678.495 1.656.916 2.656 1.348c1.702.733 3.47 1.495 3.929 2.692c.354.926-.366 2.02-.366 2.02s1.922-1.132 1.28-2.938c-.53-1.489-2.157-2.154-3.79-2.821c-1.187-.486-2.377-.972-3.15-1.777c-1.23-1.283-.376-2.747-.376-2.747",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrt);
export default __webpack_public_path__ + "static/media/scrt.3e7116559d68df32063d5318aa6554a8.svg";
export { ForwardRef as ReactComponent };